// removed by extract-text-webpack-plugin
module.exports = {"content":"src-pages----index-module---content---30-nr","blink":"src-pages----index-module---blink---1eg83"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 264
// module chunks = 35783957827783